import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-markdown-editor" }

import { ref, computed, watch, onMounted } from 'vue'
import { MdEditor, type ToolbarNames } from 'md-editor-v3'
import 'md-editor-v3/lib/style.css'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppMarkdownEditor',
  props: {
    value: { default: '' },
    modelValue: { default: '' },
    rows: { default: 3 },
    name: { default: '' },
    placeholder: { default: '' },
    autoHeight: { type: Boolean, default: false },
    minRows: { default: 3 },
    maxRows: { default: 20 }
  },
  emits: ["input", "update:modelValue", "change", "focus", "blur"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const text = ref('')

// Toolbar configuration - simplified for comment editing
const toolbars: ToolbarNames[] = [
  'bold',
  'italic',
  'strikeThrough',
  '-',
  'title',
  'quote',
  'unorderedList',
  'orderedList',
  '-',
  'link',
  'image',
  '-',
  'preview'
]

// Get the actual value from either prop
const inputValue = computed(() => props.modelValue || props.value || '')

// Count lines in current content
const contentLines = computed(() => {
  if (!props.autoHeight) return props.rows
  const lines = text.value.split('\n').length
  return Math.min(Math.max(lines, props.minRows), props.maxRows)
})

// Calculate height based on rows or content
const editorHeight = computed(() => {
  const baseHeight = 120
  const rowHeight = 24
  const rowCount = props.autoHeight ? contentLines.value : props.rows
  return `${baseHeight + (rowCount - 1) * rowHeight}px`
})

onMounted(() => {
  text.value = inputValue.value
})

watch(inputValue, (newVal) => {
  if (newVal !== text.value) {
    text.value = newVal
  }
})

const handleChange = (value: string) => {
  text.value = value
  // Emit for Vue 2 v-model
  emit('input', value)
  // Emit for Vue 3 v-model
  emit('update:modelValue', value)
  // Additional change event
  emit('change', value)
}

const handleFocus = () => {
  emit('focus')
}

const handleBlur = () => {
  emit('blur')
}

const handleUploadImg = async (files: File[], callback: (urls: string[]) => void) => {
  const urls: string[] = []
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
  for (const file of files) {
    const formData = new FormData()
    formData.append('file', file)
    try {
      const res = await fetch('/pictures_simplemde', {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': csrfToken
        },
        credentials: 'same-origin'
      })
      const result = await res.json()
      if (result.uploaded && result.url) {
        urls.push(result.url)
      }
    } catch (e) {
      console.error('Image upload failed:', e)
    }
  }
  callback(urls)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(MdEditor), {
      modelValue: text.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
      language: 'en-US',
      preview: false,
      toolbars: toolbars,
      footers: [],
      "show-code-row-number": false,
      style: _normalizeStyle({ height: editorHeight.value }),
      onOnChange: handleChange,
      onOnFocus: handleFocus,
      onOnBlur: handleBlur,
      onOnUploadImg: handleUploadImg
    }, null, 8 /* PROPS */, ["modelValue", "style"])
  ]))
}
}

})